import React from 'react';
import StarIcon from "../../../icons/StarIcon";
import {IconSize} from "../../../services/IconConstants";
import {ReviewSearchStatisticsResource} from "../../../services/api/ReviewService";


interface Props {
    stats: ReviewSearchStatisticsResource
}

const ReviewStarSummary = ({stats}: Props) => {
    return (
        <div className={"reviewStarSummary-container"}>
            <div className={"reviewStarSummary-star-container"}>
                <span className={"reviewStarSummary-star-txt"}>{stats.overallRating.toFixed(1)}</span>
                <div className={"reviewStarSummary-starsRow"}>
                    {[...Array(5)].map((_, idx) => {
                        return <StarIcon
                            key={idx}
                            size={IconSize.sm}
                            active={stats.overallRating > 0 && stats.overallRating >= (idx + 1)}
                        />
                    })}
                </div>
                <span className={"reviewStarSummary-reviewCount-txt"}>{stats.reviewCount} reviews</span>
            </div>
            <div className={"reviewStarSummary-starRating-container"}>
                <div className={"reviewStarSummary-starRating-stat"}>
                    <span>5</span>
                    <div className={"reviewStarSummary-starRating-stat-bar"}>
                        <div style={{ width: stats.fiveStarReviews + "%" }}/>
                    </div>
                </div>
                <div className={"reviewStarSummary-starRating-stat"}>
                    <span>4</span>
                    <div className={"reviewStarSummary-starRating-stat-bar"}>
                        <div style={{ width: stats.fourStarReviews + "%" }}/>
                    </div>
                </div>
                <div className={"reviewStarSummary-starRating-stat"}>
                    <span>3</span>
                    <div className={"reviewStarSummary-starRating-stat-bar"}>
                        <div style={{ width: stats.threeStarReviews + "%" }}/>
                    </div>
                </div>
                <div className={"reviewStarSummary-starRating-stat"}>
                    <span>2</span>
                    <div className={"reviewStarSummary-starRating-stat-bar"}>
                        <div style={{ width: stats.twoStarReviews + "%" }}/>
                    </div>
                </div>
                <div className={"reviewStarSummary-starRating-stat"}>
                    <span>1</span>
                    <div className={"reviewStarSummary-starRating-stat-bar"}>
                        <div style={{ width: stats.oneStarReviews + "%" }}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReviewStarSummary;